export const higherEdGradeLevels = [
  {
    value: "H1",
    label: "1st Year",
    alt: "1st",
    subjects: "college",
    sort: 1,
    short: "1 yr",
  },
  {
    value: "H2",
    label: "2nd Year",
    alt: "2nd",
    subjects: "college",
    sort: 2,
    short: "2 yr",
  },
  {
    value: "H3",
    label: "3rd Year",
    alt: "3rd",
    subjects: "college",
    sort: 3,
    short: "3 yr",
  },
  {
    value: "H4",
    label: "4th Year",
    alt: "4th",
    subjects: "college",
    sort: 4,
    short: "4 yr",
  },
  {
    value: "H5",
    label: "5th Year",
    alt: "5th",
    subjects: "college",
    sort: 5,
    short: "5 yr",
  },
];

export const terms = [
  { value: "sem1", label: "1st Sem", full: "1st Semester" },
  { value: "sem2", label: "2nd Sem", full: "2nd Semester" },
  { value: "summer", label: "Summer", full: "Summer" },
];

export const academicModes = {
  BED: "basic_ed",
  HED: "higher_ed",
};
